export default (tracker) => ({
  async linkClicked(link) {
    await tracker.track('Navigation Link Clicked', {
      menuId: link.menuId,
      submenuId: link.submenuId,
      title: link.title,
      tierOne: link.tierOne,
      tierTwo: link.tierTwo,
      tierThree: link.tierThree,
    })
  },

  async productClicked(product) {
    await tracker.track('Menu Product Clicked', {
      sku: product.sku,
      title: product.title,
      location: product.location,
      target: product.target,
    })
  },

  async showCurrencyMenu({ currentCurrency, location }) {
    await tracker.track('Currency Menu Opened', { currentCurrency, location })
  },

  async mobileMenuOpened() {
    await tracker.track('Mobile Menu Opened')
  },

  async sideMenuOpened() {
    await tracker.track('Side Menu Opened')
  },

  async sideMenuClosed() {
    await tracker.track('Side Menu Closed')
  },

  async logoClicked() {
    await tracker.track('Header Logo Clicked')
  },

  async cartClicked() {
    await tracker.track('Header Cart Link Clicked')
  },

  async promoBarLeftLinkClicked() {
    await tracker.track('Promo Bar Left Link Clicked')
  },

  async carouselLinkClicked({ baseSku: baseSku }) {
    await tracker.track('Carousel Link Clicked', {
      baseSku,
    })
  },
})
